<template>
	<div class="auction">
		<div class="fixation">
			<div class="info">
				<div class="album">
					<!-- Swiper -->
					<!-- <div class="swiper-container gallery-top">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(item,index) in imageList" :key="index">
								<img :src="item" alt="">
							</div>
						</div>
						<div class="swiper-button-next swiper-button-white"></div>
						<div class="swiper-button-prev swiper-button-white"></div>
					</div> -->
					<!-- <div class="swiper-container gallery-thumbs">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(item,index) in imageList" :key="index">
								<img :src="item" alt="">
							</div>
						</div>
					</div> -->
					<div class="auction-img">
						<el-image style="width: 100%; height: 100%;" :src="$pub.imageUrl+info.image" fit="scale-down"
							:preview-src-list="[$pub.imageUrl+info.image]">
						</el-image>
						<!-- <img :src="$pub.imageUrl+info.image" alt=""> -->
					</div>
				</div>
				<div class="explain">
					<div class="name">
						{{info.name}}
					</div>
					<div class="coming" v-if="info.status == 1">
						<div class="word">
							即将开始
						</div>
						<div class="timestr">
							距离开拍仅剩：
							<span>{{time.day}}</span>
							天
							<span>{{time.hour}}</span>
							小时
							<span>{{time.minute}}</span>
							分钟
							<span>{{time.second}}</span>
							秒
						</div>
						<div class="collect" v-if="!info.collect" @click="addCollect">
							<i class="el-icon-star-off"></i>
							关注拍品
						</div>
						<div class="collect" v-else @click="cancelCollect">
							<i class="el-icon-star-on"></i>
							取消关注
						</div>
					</div>
					<div class="limit" v-if="info.status == 2">
						<div class="word">
							正在进行
						</div>
						<div class="timestr">
							距离结束仅剩：
							<span>{{time.day}}</span>
							天
							<span>{{time.hour}}</span>
							小时
							<span>{{time.minute}}</span>
							分钟
							<span>{{time.second}}</span>
							秒
						</div>
						<div class="collect" v-if="!info.collect" @click="addCollect">
							<i class="el-icon-star-off"></i>
							关注拍品
						</div>
						<div class="collect" v-else @click="cancelCollect">
							<i class="el-icon-star-on"></i>
							取消关注
						</div>
					</div>
					<div class="grey" v-if="info.status > 2">
						<div class="word">
							<span v-if="info.status == 3">
								已结束
							</span>
							<span v-if="info.status == 4">
								流拍
							</span>
						</div>
					</div>
					<div class="start">
						<div class="price-item">
							起拍价：
							<span>¥{{info.start}}</span>
						</div>
						<div class="price-item" v-if="info.status >= 2 && info.current > 0 && $store.state.hasLogin">
							{{isPay ? '成交价' : '当前价'}}：
							<span>¥{{info.current}}</span>
						</div>
					</div>
					<div class="join" v-if="!info.isJoin&&info.status<=2">
						<div class="button" @click="joinAuction">
							参与竞拍<br />
							保证金：¥{{info.deposit}}
						</div>
						<div class="ring">
							<div @click="auctionSet">
								<i class="el-icon-message-solid"></i>
								拍卖设置
							</div>
						</div>
					</div>
					<div class="join" v-if="info.isJoin&&info.status<=2">
						<div class="button" @click="manualBid">
							出价
						</div>
						<div class="ring">
							<div @click="auctionSet">
								<i class="el-icon-question"></i>
								拍卖设置
							</div>
						</div>
					</div>
					<div class="join" v-if="info.status>2">
						<div class="button" v-if="info.status == 3 && info.isJoin && isSuccess && !isPay"
							@click="goPay">
							去支付
						</div>
						<div class="button grey" v-else-if="info.status == 3 && info.isJoin && isSuccess && isPay">
							已成交
						</div>
						<div class="button grey" v-else>
							{{info.status == 3 ? '已结束' : '流拍'}}
						</div>
					</div>
					<div class="hint">
						<i class="el-icon-warning"></i>
						提示：报名并缴纳保证金后，可参与本拍品竞拍。
					</div>
					<div class="views">
						<img src="../../../assets/commodity-logo.png" alt="">
						<div class="item">
							<i class="el-icon-user"></i>
							<span>{{info.people}}</span>
							人报名
						</div>
						<div class="item">
							<i class="el-icon-bell"></i>
							<span>{{info.ring}}</span>
							人设置提醒
						</div>
						<div class="item">
							<i class="el-icon-view"></i>
							<span>{{info.view}}</span>
							人围观
						</div>
					</div>
					<div class="other">
						<div class="item">
							保证金：{{info.deposit}}元
						</div>
						<div class="item">
							评估价：{{info.evaluated}}元
						</div>
						<div class="item">
							起拍价：{{info.start}}元
						</div>
						<!-- <div class="item">
							竞价周期：{{info.cycle}}小时
						</div> -->
						<div class="item">
							延价周期：{{info.postpone}}分钟/次
						</div>
						<div class="item">
							加价幅度：{{info.add}}元
						</div>
						<div class="item">
							<!-- 保证金截止时间：{{info.limit}}小时 -->
							保证金截止时间：{{info.limit}}
						</div>
					</div>
				</div>
			</div>
			<div class="course" v-if="hintFlag">
				<div class="block">
					<div class="block-title">
						竞拍流程
					</div>
					<div class="block-list">
						<div class="step" v-for="(item,index) in step" :key="index">
							<div class="step-index">
								<img :src="item.icon" alt="">
							</div>
							<div class="step-mid">
								<div class="step-key">
									{{item.key}}
								</div>
								<div class="step-value">
									{{item.value}}
								</div>
							</div>
							<div class="step-arrow" v-if="index<5">
								<img src="../../../assets/arrow.png" alt="">
							</div>
						</div>
					</div>
					<div class="close" @click="closeHint">
						<span>
							不再提示
							<i class="el-icon-close"></i>
						</span>
					</div>
				</div>
			</div>
			<div class="introduce">
				<div class="detail">
					<div class="title">
						<div :class="'item '+(datumIndex == index? 'selected': '')" v-for="(item,index) in datum"
							:key="index" @click="detailChange(index,item.target)">
							<span>{{item.name}}</span>
							<!-- <a :href="'#'+item.target">
								{{item.name}}
							</a> -->
						</div>
						<div v-if="info.status >= 2" :class="'item '+(datumIndex == 5? 'selected': '')"
							@click="detailChange(5)">
							<span>竞价记录（{{total}}）</span>
						</div>
					</div>
					<div class="cont" v-if="datumIndex < 5">
						<div class="block" id="block_1">
							<div class="block_title">
								拍品介绍
							</div>
							<div class="richtext" v-html="introduce">

							</div>
						</div>
						<div class="block" id="block_2">
							<div class="block_title">
								拍卖公告
							</div>
							<div class="richtext" v-html="notice">

							</div>
						</div>
						<div class="block" id="block_3">
							<div class="block_title">
								资料下载
							</div>
							<div class="richtext">
								<div class="file">
									<span>相关附件下载</span>
								</div>
								<!-- <li v-for="(item,index) in fileList" :key="index">
									<a :href="item.filePath" target="_blank">
										{{item.fileName}}
									</a>
								</li> -->
								<li>
									<a v-if="otherFile!=''" :href="otherFile" target="_blank">
										点击下载相关资料文件
									</a>
									<span v-else>当前暂无相关资料文件</span>
								</li>
							</div>
						</div>
						<div class="block" id="block_4">
							<div class="block_title">
								报名须知
							</div>
							<div class="richtext" v-html="diccover">

							</div>
						</div>
						<div class="block" id="block_5">
							<div class="block_title">
								拍卖规则
							</div>
							<div class="richtext" v-html="rule">

							</div>
						</div>
					</div>
					<div class="record" v-else>
						<div class="block" id="block_6">
							<div class="block_title">
								竞价记录
							</div>
							<div class="block-table" v-if="tableData.length>0">
								<el-table :data="tableData" style="width: 100%" :border="true"
									:header-cell-style="{background:'#eaf0fa'}">
									<el-table-column label="状态" align="center">
										<template v-slot="scope">
											<slot :row="scope.row" :column="scope.column">
												{{scope.$index == 0 ? '领先' : '出局'}}
											</slot>
										</template>
									</el-table-column>
									<el-table-column prop="biddingNo" label="竞买号" align="center" width="340">
									</el-table-column>
									<el-table-column prop="price" label="价格" align="center">
									</el-table-column>
									<el-table-column prop="biddingTime" label="时间" align="center">
									</el-table-column>
								</el-table>
							</div>
							<div class="pager" v-if="tableData.length>0">
								<el-pagination background layout="total, prev, pager, next, jumper" :total="total"
									:pager-count="11" :page-size="pageSize" :current-page="currentPage"
									@current-change="pageChange">
								</el-pagination>
							</div>
							<div v-else>
								<el-empty description="当前暂无竞价记录">
								</el-empty>
							</div>
						</div>
					</div>
				</div>
				<div class="recommend">
					<!-- <div class="store">
						<div class="store-title">
							<img src="../../../assets/commodity-logo.png" alt="">
						</div>
						<div class="store-info">
							<div class="store-name">
								{{store.name}}
							</div>
							<router-link to="">
								查看全部标的物
							</router-link>
						</div>
					</div> -->
					<div class="list">
						<div class="list-title">
							相关推荐
						</div>
						<ul>
							<li v-for="(item,index) in recommend" :key="index" @click="useThis(item)">
								<div class="r-img">
									<img :src="$pub.imageUrl+item.lotPictrueUrl" alt="">
								</div>
								<div class="r-name">
									{{item.lotName}}
								</div>
								<div class="r-price">
									起拍价：<span>¥{{item.startPrice}}</span>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<auctionDialog v-if="dialogFlag" :formData="formData" :info="info" @closeAuction="dialogFlag = false">
		</auctionDialog>
		<el-dialog :visible="bidFlag" title="手动出价" @close="bidFlag = false" width="500px" top="400px" :modal="false">
			<el-form ref="bidForm" :model="bidForm" label-width="80px">
				<el-form-item label="出价:" prop="bid">
					<el-input type="number" :min="info.current+info.add" v-model="bidForm.bid"
						:placeholder="'请输入您的出价：当前价格'+info.current+'，最低出价：'+(info.current+info.add)">
						<!-- <el-input type="number" disabled v-model="bidForm.bid" placeholder="请选择加价幅度">
						<el-button slot="prepend" icon="el-icon-minus" :disabled="bidForm.bid == info.current"
							@click="minusBid"></el-button>
						<el-button slot="append" icon="el-icon-plus" @click="addBid"></el-button> -->
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="danger" plain round @click="bidFlag = false">取消</el-button>
					<el-button type="danger" round @click="submitBid">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import 'swiper/dist/js/swiper'
	import 'swiper/dist/css/swiper.css'
	import Swiper from 'swiper'
	export default {
		name: 'auction',
		data() {
			return {
				id: '',
				imageList: [
					// require('../../../assets/images/'),
				],
				info: {
					image: '',
					name: '',
					now: 0,
					number: 0,
					evaluated: 0,
					view: 0,
					people: 0,
					start: 0,
					current: 0,
					deposit: 0,
					tag: [],
					status: 1,
					id: '',
					ring: '',
					postpone: '',
					cycle: '',
					limit: 0,
					collect: false,
					isJoin: false
				},
				time: {
					day: 0,
					hour: 0,
					minute: 0,
					second: 0
				},
				step: [{
						icon: require('../../../assets/step-1.png'),
						key: '阅读公告',
						value: '注意竞买要求及相关约定'
					},
					{
						icon: require('../../../assets/step-2.png'),
						key: '联系处置方',
						value: '未尽事宜咨询处置方'
					},
					{
						icon: require('../../../assets/step-3.png'),
						key: '交保证金',
						value: '确认提交成功'
					},
					{
						icon: require('../../../assets/step-4.png'),
						key: '开始竞价',
						value: '注意开拍时间'
					},
					{
						icon: require('../../../assets/step-5.png'),
						key: '竞价成功',
						value: '价高者得'
					},
					{
						icon: require('../../../assets/step-6.png'),
						key: '线下付款交割',
						value: '联系处置方确认相关流程'
					}
				],
				datum: [{
						target: 'block_1',
						name: '拍品介绍'
					},
					{
						target: 'block_2',
						name: '拍卖公告'
					},
					{
						target: 'block_3',
						name: '资料下载'
					},
					{
						target: 'block_4',
						name: '报名须知'
					},
					{
						target: 'block_5',
						name: '拍卖规则'
					}
				],
				datumIndex: 0,
				introduce: '',
				notice: '',
				// fileList: [],
				otherFile: '',
				diccover: '',
				rule: '',
				tableData: [],
				total: 0,
				pageSize: 15,
				currentPage: 1,
				store: {
					name: '北京大德拍卖'
				},
				recommend: [],
				dialogFlag: false,
				formData: {
					username: '',
					phone: '',
					email: '',
					address: '',
					top: 0,
					min: '',
					max: '',
					step: 0,
					remind: true,
					setTop: 0
				},
				bidFlag: false,
				bidForm: {
					bid: 0
				},
				hintFlag: true,
				interVal: '',
				isSuccess: false,
				orderId: '',
				isPay: false
			};
		},
		watch: {
			getCommodityPrice(msg) {
				if (msg.id == this.id) {
					this.info.current = msg.price
					this.addBid()
					this.fetchRecord()
				}
			}
		},
		computed: {
			getCommodityPrice() {
				return this.$store.state.messageCommodity
			}
		},
		methods: {
			goPay() {
				this.$router.push({
					path: '/payment',
					query: {
						order: this.orderId,
						type: 2
					}
				})
			},
			initSwiper() {
				let galleryThumbs = new Swiper('.gallery-thumbs', {
					spaceBetween: 10,
					slidesPerView: 5,
					loop: true,
					freeMode: true,
					loopedSlides: 5, //looped slides should be the same
					watchSlidesVisibility: true,
					watchSlidesProgress: true,
				});
				let galleryTop = new Swiper('.gallery-top', {
					spaceBetween: 10,
					loop: true,
					loopedSlides: 5, //looped slides should be the same
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					thumbs: {
						swiper: galleryThumbs,
					},
					autoplay: { //自动开始
						delay: 2500, //时间间隔
						disableOnInteraction: false, //*手动操作轮播图后不会暂停*
					}
				});
			},
			pageChange(e) {
				this.currentPage = e
				this.fetchRecord()
			},
			joinAuction() {
				if (!this.$store.state.hasLogin) {
					this.noLogin()
					return
				}
				this.$api.frontJoinAuction({
					memberId: this.$store.state.userinfo.userId,
					lotId: this.id,
					lotName: this.info.name,
					bondPrice: this.info.deposit
				}, res => {
					if (res.code == 200) {
						this.$router.push({
							path: '/payment',
							query: {
								order: res.data,
								type: 1
							}
						})
					}
				})
			},
			manualBid() {
				this.bidForm.bid = this.info.current == 0 ? this.info.start : (this.info
					.current + this.info.add)
				this.bidFlag = true
			},
			noLogin() {
				this.$confirm('当前尚未登录，请在登录后继续操作。', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$parent.openLogin()
				}).catch(() => {});
			},
			auctionSet() {
				if (!this.$store.state.hasLogin) {
					this.noLogin()
					return
				}
				if (!this.info.isJoin) {
					this.$confirm('请先缴纳保证金报名参加拍卖。', '提示', {
						confirmButtonText: '立即参加',
						cancelButtonText: '暂不参加',
						type: 'warning'
					}).then(() => {
						this.joinAuction()
					}).catch(() => {

					});
					return
				}
				this.dialogFlag = true
			},
			fetchData() {
				this.$api.frontCommodityDetail({
					id: this.id,
					userId: this.$store.state.hasLogin ? this.$store.state.userinfo.userId : ''
				}, res => {
					if (res.code == 200) {
						this.info = {
							image: res.data[0].lotPictrueUrl,
							name: res.data[0].lotName,
							now: res.data[0].currentPrice == null ? res.data[0].startPrice : res.data[0]
								.currentPrice,
							number: res.data[0].setReminderNumber,
							evaluated: res.data[0].evaluationPrice,
							view: res.data[0].watchFrequency == null ? 0 : res.data[0].watchFrequency,
							people: res.data[0].enrollNumber,
							start: res.data[0].startPrice,
							current: res.data[0].currentPrice == null ? 0 : res.data[0].currentPrice,
							deposit: res.data[0].bond,
							tag: res.data[0].lotLabel.split(','),
							status: res.data[0].auctionStatus,
							id: res.data[0].id,
							ring: res.data[0].setReminderNumber == null ? 0 : res.data[0].setReminderNumber,
							cycle: res.data[0].biddingPeriod,
							postpone: res.data[0].delayPeriod,
							add: res.data[0].priceIncreaseRange == null ? 0 : res.data[0].priceIncreaseRange,
							// limit: res.data[0].bondEndTime == null ? 0 : res.data[0].bondEndTime,
							limit: res.data[0]['endTime'],
							collect: res.data[0].collectionMemberId,
							isJoin: res.data[0].bondMemberId,
							startTime: res.data[0]['startTime'],
							endTime: res.data[0]['endTime']
						}
						this.recommend = res.data[1]
						this.introduce = res.data[0].objectIntroduce
						this.notice = res.data[0].auctionAnnouncement
						this.otherFile = res.data[0].dataUrl
						this.diccover = res.data[0].notice
						this.rule = res.data[0].auctionRule
						this.formData.top = res.data[0].currentPrice ? res.data[0].currentPrice : res.data[0]
							.startPrice
						this.formData.setTop = res.data[0].maxPrice ? res.data[0].maxPrice : 0
						this.formData.remind = res.data[0].isRemind == 0 ? false : true
						if (this.info.status <= 2) {
							this.startInterval()
						}
					}
				})
			},
			startInterval() {
				this.interVal = setInterval(() => {
					let transTime = ''
					let targetStatus = 0
					if (this.info.status == 1) {
						transTime = this.info['startTime']
						targetStatus = 2
					} else {
						transTime = this.info['endTime']
						targetStatus = 3
					}
					let diff = this.$pub.timeStampDifferene(transTime)
					if (diff.t == 0) {
						this.$api.frontAuctionStausChange({
							status: targetStatus,
							id: this.id
						}, res => {
							if (res.code == 200) {
								location.reload()
							}
						})
					} else {
						this.time = {
							day: diff.day,
							hour: diff.h,
							minute: diff.m,
							second: diff.s
						}
					}
				}, 1000)
			},
			useThis(node) {
				this.$router.push({
					path: '/auction',
					query: {
						id: node.id
					}
				})
				location.reload()
			},
			detailChange(index, t) {
				this.datumIndex = index
				let target = document.getElementById(t)
				window.scrollTo(0, target.offsetTop)
			},
			fetchRecord() {
				this.$api.frontCommodityRecord({
					lotId: this.id,
					pageSize: this.pageSize,
					pageNum: this.currentPage
				}, res => {
					if (res.code == 200) {
						this.tableData = res.data.list
						this.total = res.data.total
					}
				})
			},
			addCollect() {
				this.$api.frontAddCollect({
					lotId: this.id,
					memberId: this.$store.state.userinfo.userId
				}, res => {
					if (res.code == 200) {
						this.info.collect = true
						this.$message({
							message: '添加关注成功！',
							type: 'success'
						})
					}
				})
			},
			cancelCollect() {
				this.$api.frontCancelCollect({
					lotId: this.id,
					memberId: this.$store.state.userinfo.userId
				}, res => {
					if (res.code == 200) {
						this.info.collect = false
						this.$message({
							message: '取消关注成功！',
							type: 'success'
						})
					}
				})
			},
			addViewRecord() {
				if (this.$store.state.hasLogin) {
					this.$api.frontViewRecord({
						memberId: this.$store.state.userinfo.userId,
						lotId: this.id
					}, res => {
						if (res.code == 200) {
							console.log('添加浏览记录成功')
						}
					})
				}
			},
			minusBid() {
				if (this.bidForm.bid > (this.info.current + this.info.add)) {
					this.bidForm.bid = this.bidForm.bid - this.info.add
				}
			},
			addBid() {
				this.bidForm.bid = this.bidForm.bid + this.info.add
			},
			submitBid() {
				if (this.bidForm.bid < this.info.current + this.info.add) {
					this.$message({
						type: 'error',
						message: '当前最低出价：' + (this.info.current + this.info.add) + '元，请重新出价。'
					})
					return
				}
				this.$api.frontManualBid({
					lotId: this.id,
					memberId: this.$store.state.userinfo.userId,
					price: this.bidForm.bid
				}, res => {
					if (res.code == 200) {
						this.bidFlag = false
						this.getData()
						this.$message({
							message: '出价成功',
							type: 'success',
							duration: 2000
						})
					}
				})
			},
			closeHint() {
				this.hintFlag = false
				sessionStorage.setItem('hintFlag', 1)
			},
			queryAuctionResult() {
				if (this.$store.state.hasLogin) {
					this.$api.frontQueryAuctionResult({
						id: this.id,
						memberId: this.$store.state.userinfo.userId
					}, res => {
						if (res.code == 200) {
							if (res.data[0]) {
								this.isSuccess = true
								this.orderId = res.data[1]
								this.queryOrderResult()
							}
						}
					})
				}
			},
			queryOrderResult() {
				this.$api.frontOrderDetail({
					lotOrderId: this.orderId,
					userId: this.$store.state.userinfo.userId
				}, res => {
					if (res.code == 200) {
						this.isPay = res.data.payStatus == 1
					}
				})
			},
			getData() {
				this.fetchData()
				this.fetchRecord()
				this.addViewRecord()
				this.queryAuctionResult()
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.id = this.$route.query.id
			this.hintFlag = !sessionStorage.getItem('hintFlag')
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			// this.initSwiper()
			this.getData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
			clearInterval(this.interVal)
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.swiper-container {
		width: 100%;
		height: 100%;
		margin-left: auto;
		margin-right: auto;
	}

	.swiper-slide {

		// background-size: cover;
		// background-position: center;
		img {
			width: 100%;
			height: 100%;
		}
	}

	.gallery-top {
		height: 80%;
		width: 100%;
	}

	.gallery-thumbs {
		height: 20%;
		box-sizing: border-box;
		padding: 10px 0 0 0;
	}

	.gallery-thumbs .swiper-slide {
		height: 100%;
		opacity: 0.4;
	}

	.gallery-thumbs .swiper-slide-thumb-active {
		opacity: 1;
	}

	.fixation {
		padding-top: @vue-spacing-col-lg;

		.info {
			width: 100%;
			height: 460px;
			border: 1px solid @vue-border-color;
			box-sizing: border-box;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0px @vue-spacing-row-base + 4;

			.album {
				width: 420px;
				height: 390px;
				display: flex;
				justify-content: center;
				align-items: center;

				.auction-img {
					width: 100%;
					height: 100%;
					display: flex;
					justify-content: center;
					align-items: center;

					img {
						max-width: 100%;
						max-height: 100%;
					}
				}
			}

			.explain {
				width: 660px;
				height: 390px;

				.name {
					width: 100%;
					height: 50px;
					display: flex;
					align-items: center;
					font-size: @vue-font-size-sm + 2;
					color: @vue-text-color;
					font-weight: bold;
				}
			}

			.coming,
			.limit,
			.grey {
				width: 100%;
				height: 40px;
				display: flex;
				border: 1px solid @vue-border-color;
				box-sizing: border-box;

				.word {
					width: 130px;
					height: 100%;
					padding-left: @vue-spacing-row-base;
					box-sizing: border-box;
					display: flex;
					align-items: center;
					border-radius: 0px 20px 20px 0px;
					color: @vue-text-color-inverse;
					line-height: 40px;
				}

				.timestr {
					width: calc(100% - 280px);
					height: 100%;
					padding-left: @vue-spacing-row-base;
					box-sizing: border-box;
					color: @vue-text-color-grey;
					display: flex;
					align-items: center;
					line-height: 40px;

					span {
						color: @vue-text-color-red;
						margin: 0px 2px;
					}
				}

				.collect {
					width: 150px;
					height: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					line-height: 40px;
					cursor: pointer;

					i {
						font-size: @vue-font-size-sm + 4;
						color: @vue-text-color-red;
						margin-right: @vue-spacing-row-sm / 2;
					}
				}
			}

			.coming {
				background: #f0f0f1;

				.word {
					background: @vue-bg-color-dg;
				}
			}

			.limit {
				background: #fdf1f1;

				.word {
					background: @vue-bg-color-red;
				}
			}

			.grey {
				background: @vue-bg-color-grey;

				.word {
					background: #999999;
					color: @vue-text-color-inverse
				}
			}

			.start {
				width: 100%;
				height: 50px;
				display: flex;
				align-items: center;

				span {
					color: @vue-text-color-red;
					font-size: @vue-font-size-sm + 4;
					font-weight: bold;
					margin-right: @vue-spacing-row-sm;
				}
			}

			.join {
				width: 100%;
				height: 50px;
				display: flex;

				.button {
					width: 200px;
					height: 100%;
					background: @vue-bg-color-red;
					color: @vue-text-color-inverse;
					display: flex;
					justify-content: center;
					align-items: center;
					flex-wrap: wrap;
					align-content: center;
					text-align: center;
					cursor: pointer;
				}

				.grey {
					background: #999999;
					color: @vue-text-color-inverse;
				}

				.ring {
					height: 100%;
					display: flex;
					align-items: center;
					margin-left: @vue-spacing-row-base;

					div {
						height: 40px;
						display: flex;
						align-items: center;
						font-size: @vue-font-size-sm + 2;
						color: @vue-text-color-red;
						line-height: 50px;
						cursor: pointer;
						padding: 0px 8px;
						box-sizing: border-box;

						i {
							font-size: @vue-font-size-base;
							margin-right: @vue-spacing-row-sm;
						}
					}

					div:hover {
						background: @vue-bg-color-grey;
					}
				}
			}

			.hint {
				width: 100%;
				height: 30px;
				margin-top: @vue-spacing-col-base;
				border: 1px solid @vue-border-color-red;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				padding-left: @vue-spacing-row-sm;
				font-size: @vue-font-size-min;
				line-height: 30px;
				background: #fffde0;
				color: #f79803;

				i {
					margin-right: @vue-spacing-row-sm;
				}
			}

			.views {
				width: 100%;
				height: 40px;
				border-top: 1px solid @vue-border-color;
				border-bottom: 1px solid @vue-border-color;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				margin-top: @vue-spacing-col-base;

				.item {
					border-right: 1px solid @vue-border-color;
					padding-right: @vue-spacing-row-base;
					margin-left: @vue-spacing-row-base;
					font-size: @vue-font-size-min;

					i {
						margin-right: @vue-spacing-row-sm / 2;
					}

					span {
						color: @vue-text-color-red;
					}
				}
			}

			.other {
				width: 100%;
				display: flex;
				flex-wrap: wrap;
				font-size: @vue-font-size-min;
				color: @vue-text-color-grey;
				margin-top: @vue-spacing-col-base;

				.item {
					width: 33.3%;
					height: 30px;
					display: flex;
					align-items: center;
				}
			}
		}

		.course {
			width: 100%;
			margin-top: @vue-spacing-col-lg;

			.block {
				width: 100%;
				height: 90px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				border: 1px solid @vue-border-color;
				box-sizing: border-box;

				.block-title {
					width: 80px;
					height: 55px;
					text-align: center;
					vertical-align: middle;
					font-size: @vue-font-size-sm + 4;
					border-right: 1px solid @vue-border-color;
					padding: 0px @vue-spacing-row-sm;
					box-sizing: border-box;
				}

				.block-list {
					width: calc(100% - 110px);
					height: 100%;
					display: flex;
					flex-wrap: wrap;
					padding: 15px 0px;
					box-sizing: border-box;

					.step {
						height: 100%;
						display: flex;
						justify-content: space-between;
						align-items: center;

						.step-index {
							width: 50px;
							display: flex;
							align-items: center;
							justify-content: center;
						}

						.step-mid {

							.step-key,
							.step-value {
								width: 100%;
								height: 30px;
								display: flex;
								align-items: center;
							}

							.step-key {
								font-size: @vue-font-size-sm - 2;
								font-weight: bold;
							}

							.step-value {
								font-size: @vue-font-size-min;
							}
						}

						.step-arrow {
							width: 40px;
							height: 40px;

							img {
								width: 100%;
								height: 100%;
							}
						}
					}
				}

				.close {
					width: 30px;
					height: 100%;
					background: @vue-bg-color;
					display: flex;
					flex-direction: column;
					justify-content: center;
					font-size: @vue-font-size-min;
					padding-left: 8px;
					box-sizing: border-box;
					cursor: pointer;
					border-left: 1px solid @vue-border-color;
					box-sizing: border-box;
				}

				.close:hover {
					color: @vue-text-color-active;
				}
			}
		}

		.introduce {
			width: 100%;
			display: flex;
			justify-content: space-between;
			margin-top: @vue-spacing-col-lg;

			.detail {
				width: 990px;

				.title {
					width: 100%;
					height: 40px;
					border: 1px solid @vue-border-color;
					background: @vue-bg-color-grey;
					border-bottom: 1px solid @vue-border-color-red;
					display: flex;

					.item {
						width: 130px;
						height: 100%;
						font-size: @vue-font-size-sm - 2;
						cursor: pointer;

						a,
						span {
							width: 100%;
							height: 100%;
							color: @vue-text-color;
							display: flex;
							justify-content: center;
							align-items: center;
						}
					}

					.selected {
						background: @vue-bg-color-red;

						a,
						span {
							color: @vue-text-color-inverse
						}
					}
				}

				.cont,
				.record {
					width: 100%;

					.block {
						width: 100%;
						padding: 0px @vue-spacing-row-base;
						box-sizing: border-box;

						.block_title {
							width: 100%;
							height: 100px;
							background: url(../../../assets/commodity-block-title.png) no-repeat;
							background-position: center;
							display: flex;
							justify-content: center;
							align-items: center;
							font-size: @vue-font-size-sm;
							color: @vue-text-color-red;
						}

						.richtext {
							width: 100%;

							.file {
								width: 100%;
								height: 40px;
								border-bottom: 1px solid @vue-border-color;

								span {
									display: inline-block;
									height: 100%;
									line-height: 40px;
									border-bottom: 1px solid @vue-border-color-red;
									font-size: @vue-font-size-sm - 2;
								}
							}

							li {
								width: 100%;
								height: 40px;

								a {
									display: flex;
									align-items: center;
									height: 100%;
									color: @vue-text-color-active;
									font-size: @vue-font-size-sm - 2;
								}
								
								span{
									display: flex;
									align-items: center;
									height: 100%;
									color: @vue-text-color-grey;
									font-size: @vue-font-size-sm;
								}
							}
						}

						.pager {
							width: 100%;
							height: 70px;
							display: flex;
							align-items: center;
							justify-content: flex-end;
						}
					}
				}
			}

			.recommend {
				width: 200px;

				.store,
				.list {
					width: 100%;
					border: 1px solid @vue-border-color;

					.store-title,
					.list-title {
						width: 100%;
						height: 40px;
						border-bottom: 1px solid @vue-border-color;
						background: @vue-bg-color-grey;
						display: flex;
						justify-content: center;
						align-items: center;
					}

					.store-info {
						width: 100%;
						padding: @vue-spacing-col-base @vue-spacing-row-base;
						box-sizing: border-box;

						.store-name {
							width: 100%;
							line-height: 24px;
							font-size: @vue-font-size-sm - 2;
							text-align: center;
							padding-bottom: @vue-spacing-row-sm;
						}

						a {
							width: 100%;
							height: 30px;
							border: 1px solid @vue-border-color-red;
							box-sizing: border-box;
							display: flex;
							justify-content: center;
							align-items: center;
							color: @vue-text-color-red;
							font-size: @vue-font-size-min;
						}
					}
				}

				.store {
					margin-bottom: @vue-spacing-col-base;
				}

				.list {

					ul {
						width: 100%;

						li {
							width: 100%;
							padding: @vue-spacing-col-sm @vue-spacing-row-sm;
							box-sizing: border-box;
							margin-bottom: @vue-spacing-col-sm;
							cursor: pointer;

							.r-img {
								width: 100%;

								img {
									width: 100%;
									display: block;
								}
							}

							.r-name {
								width: 100%;
								line-height: 20px;
								font-size: @vue-font-size-min;
								padding: @vue-spacing-col-sm 0px;
							}

							.r-price {
								font-size: @vue-font-size-min;
								color: @vue-text-color-dg;

								span {
									font-size: @vue-font-size-sm;
								}
							}
						}
					}
				}
			}
		}
	}
</style>
